import React from "react";

import css from "./Divider.module.scss";

type DividerProps = React.DetailedHTMLProps<React.HTMLAttributes<HTMLHRElement>, HTMLHRElement> & {
	/**
	 * Custom class name to apply to the divider
	 **/
	className?: string;
};

/**
 * Layout component used to visually separate content in a group.
 * Displays a thin horizontal line, and renders a `hr` tag.
 */
export const Divider = ({ className, ...rest }: DividerProps) => {
	return <hr className={`${css.divider} ${className}`} {...rest} role="separator" />;
};
